import React, { useState } from 'react';
import { Alert, AlertTitle, AlertDescription } from './components/ui/alert';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from './components/ui/dialog';
import { Button } from './components/ui/button';

export function WarningMessage({ header, message }) {
  return (
    <Alert variant="warning" className="theEnd" data-testid="warning-message">
      <AlertTitle>{header}</AlertTitle>
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}

export function SessionInformation({ sessionIdPublic }) {
  const [open, setOpen] = useState(false);
  const public_link = window.location + '?view=' + sessionIdPublic;
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline">Share session to observers</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Share the following link to the observers</DialogTitle>
        </DialogHeader>
        <DialogDescription asChild>
          <div className="px-6 py-4">
            <a href={public_link} className="link break-all text-sm">
              {public_link}
            </a>
          </div>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
}
